import React, { useEffect, useContext } from 'react';
import CargomaticCard from 'components/v2/card';
import { useTranslation } from 'react-i18next';
import CircleButton from 'components/v2/buttons/CircleButton';
import moment from 'moment';
import { showToast } from 'stores/ToastStore';
import formatMoney from 'utils/formatters/Money';
import DownloadIcon from '../../../v2/icons/DownloadIcon';
import { useGetSignedUrls } from '../../../../utils/DocumentsHooks';
import ArrowTopRightOnSquareIcon from '../../../v2/icons/ArrowTopRightOnSquareIcon';

function CreditMemoTable({ creditMemoList = [] }) {
  const { t } = useTranslation();

  return (
    (<CargomaticCard
      dataTestId="CargomaticCard-3d249252"
      className="mb-6"
      header={() => (
        <div data-testid="div-8a8c9c1c" className="flex items-center justify-between">
          <h3 data-testid="h3-bfb6b93e" className="my-0 mr-8">{t('CREDIT_MEMO', { count: 2 })}</h3>
        </div>
      )}>
      <div
        data-testid="div-8354dcaa"
        className="-mb-4 card--no-x-padding card--no-top-padding sm:-mb-4">
        <div data-testid="div-8769682e" className="overflow-x-auto">
          <table data-testid="table-632bdc93" className="default-table">
            <thead data-testid="thead-b2b795a4" className="text-bold">
              <tr data-testid="tr-d08327ab">
                <th data-testid="th-1732c57c" className="">
                  <span data-testid="span-2089c6ec" className="ml-6">{t('NAME')}</span>
                </th>
                <th data-testid="th-fb320ccb" className="">{t('AMOUNT')}</th>
                <th data-testid="th-d535e48b" className="">
                  <span data-testid="span-9fd1c1ea" className="ml-4">{t('DATE')}</span>
                </th>
                <th data-testid="th-a7176149" className="">
                  <span data-testid="span-61c25e58" className="ml-6">{t('CREATED_BY')} </span>
                </th>
                <th data-testid="th-a6843d58" className="">
                  <span data-testid="span-061c3e69" className="ml-2">{t('PDF')}</span>
                </th>
              </tr>
            </thead>
            <tbody data-testid="tbody-44ec6fdf" className="">
              {creditMemoList.map(
                (
                  {
                    number,
                    amount_due: amountDue,
                    timestamp: createdDate,
                    created_by: createdBy,
                    _id: id,
                    currency,
                  },
                  index
                ) => {
                  return (
                    <CreditMemoRow
                      number={number}
                      amountDue={amountDue}
                      createdDate={createdDate}
                      id={id}
                      createdBy={createdBy}
                      currency={currency}
                    />
                  );
                },
              )}
            </tbody>
          </table>
        </div>
      </div>
    </CargomaticCard>)
  );
}

const CreditMemoRow = ({
  amountDue,
  createdBy,
  createdDate,
  id,
  number,
  currency,
}) => {
  const { t } = useTranslation();
  const { data: signedUrlsData, error: signedUrlsError } = useGetSignedUrls({
    foreignKeys: [id],
  });
  const signedUrl = signedUrlsData?.signedUrls?.[0]?.signedUrl;

  useEffect(() => {
    if (signedUrlsError) {
      showToast(
        t('GET_SIGNED_URL_ERROR'),
        t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
          error: signedUrlsError,
        }),
        'error',
      );
    }
  }, [signedUrlsError]);
  return (
    (<tr data-testid="tr-79b18f87">
      <td data-testid="td-fef41e98">
        <div data-testid="div-e5068598" className="flex justify-start items-center">
          <a
            data-testid="a-cf2a79dd"
            className="flex justify-start items-center"
            target="_blank"
            href={`/invoices/${id}`}
            rel="noreferrer">
            {number}
            <ArrowTopRightOnSquareIcon className="ml-1 w-5 h-5" />
          </a>
        </div>
      </td>
      <td data-testid="td-d88f99a9">
        <span data-testid="span-b1a39882" className="">{formatMoney(amountDue, currency)}</span>
      </td>
      <td data-testid="td-da7842ab">{moment(createdDate).format('L')}</td>
      <td data-testid="td-4b3b0b0d">{createdBy}</td>
      <td data-testid="td-4c264c54" className="cursor-pointer">
        <CircleButton
          dataTestId="CircleButton-f90285ab"
          onClick={() => {
            window.open(signedUrl, '_blank', 'noreferrer');
          }}>
          <DownloadIcon />
        </CircleButton>
      </td>
    </tr>)
  );
};

export default CreditMemoTable;
